<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Selected Equipments For Delete'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>
  <div class="ttmodal__body">
  
    <table  class="table table--full-width table--striped">
      <thead>
        <tr>
          <td>Equipment</td>
          <td>Level</td>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let info of selectedEquipment">
          <tr>
            <td>{{info.SerialNo}} : {{info.UnitNo}} </td>
            <td>{{info.Level}}</td> 
          </tr>
        </ng-container>
      </tbody>
      
     
    </table>
    <div style="max-width: 750px;">
      The equipment listed is currently using evaluation ranges set at Jobsite, Customer or Dealership level. 
      These ranges cannot be deleted at equipment level. 
      To delete or edit these ranges select the applicable level and Jobsite/Customer/Dealership above.
      If you would like specif evaluation ranges for the equipment listed you can apply equipment level ranges.
    </div>
     
    </div>
  <div class="ttmodal__footer">
   
    <button mat-raised-button color="warn" (click)="onNoClick()"><span class="material-icons button__icon">check</span>
      <span class="button__text">{{'OK'| translate | async}}</span></button>
  </div>
</div>
